const state = {
  exchangeRate: undefined,
  countries: undefined,
  selectedPersonType: undefined,
  selectedPlan: undefined,
  studentsNumber: undefined,
  billing: undefined,
  braintreeResponse: undefined,
  braintreeClientTokenResponse: undefined,
  selectedCouponId: undefined
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/purchase/state.js